import { useEffect, useState } from 'react'

import type { FC } from 'react'

type TimeProps = {
  isRunning?: boolean
  startedAt: number
}

const Time: FC<TimeProps> = ({ isRunning = false, startedAt }) => {
  const [time, setTime] = useState(Math.round(Math.max(0, Date.now() / 1000 - startedAt)))
  const minutes = String(Math.floor(time / 60)).padStart(2, '0')
  const seconds = String(Math.floor(time % 60)).padStart(2, '0')

  useEffect(() => {
    const interval: NodeJS.Timeout | undefined = undefined

    if (isRunning) {
      setInterval(() => {
        setTime(Math.round(Math.max(0, Date.now() / 1000 - startedAt)))
      }, 250)
    }
    return () => {
      clearInterval(interval)
    }
  }, [isRunning, startedAt])

  return <div className="text-xs text-text">{`${minutes}' ${seconds}"`}</div>
}

export default Time
